/**
 * "Pievienots grozam" upsell pop-up (snippets/emk-upsell-popup.liquid; Figma 72:454 / 74:4655).
 *
 * The theme fires "product:added" from the buy button; its header listens on <html> and opens the cart drawer.
 * We catch the event first (capture phase on window), show the pop-up instead, and when the shopper is done
 * we add the selected add-ons and re-send "product:added", so the theme refreshes and opens the cart as usual.
 */
(function () {
  var popup = document.querySelector("[data-emk-upsell]");
  if (!popup) return;

  var list = popup.querySelector("[data-emk-upsell-list]");
  var productId = popup.getAttribute("data-product-id");
  var ready = null; // promise: resolves when the add-on list is final
  var pending = null; // the intercepted product:added detail

  function money(cents) {
    var value = (cents / 100).toFixed(2).replace(".", ",");
    return "€" + value;
  }

  function cards() {
    return list.querySelectorAll("[data-emk-upsell-item]");
  }

  // Source 2: Shopify complementary products, only when no metafield list is set
  function loadComplementary() {
    if (popup.getAttribute("data-source") === "metafield") return Promise.resolve();
    var url = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/") +
      "recommendations/products?section_id=emk-upsell-items&intent=complementary&limit=3&product_id=" + productId;
    return fetch(url)
      .then(function (r) { return r.ok ? r.text() : ""; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, "text/html");
        var found = doc.querySelectorAll("[data-emk-upsell-item]");
        if (!found.length) return;
        list.innerHTML = "";
        found.forEach(function (card) { list.appendChild(document.importNode(card, true)); });
        popup.setAttribute("data-source", "complementary");
      })
      .catch(function () {});
  }

  // Selected variant of the main product (price, image and saving shown at the top)
  function mainVariant() {
    var form = document.querySelector('.product-block-list__item--info form[action*="/cart/add"]');
    var idInput = form && form.querySelector('[name="id"]');
    var json = document.querySelector("[data-product-json]");
    if (!idInput || !json) return null;
    try {
      var data = JSON.parse(json.textContent);
      return data.product.variants.filter(function (v) { return String(v.id) === String(idInput.value); })[0] || null;
    } catch (e) {
      return null;
    }
  }

  function update() {
    var selected = popup.querySelectorAll('[data-emk-upsell-item].is-selected');
    var saving = 0;
    var v = mainVariant();
    var qty = pending ? pending.quantity || 1 : 1;
    if (v && v.compare_at_price > v.price) saving += (v.compare_at_price - v.price) * qty;
    selected.forEach(function (card) { saving += parseInt(card.getAttribute("data-saving"), 10) || 0; });

    var row = popup.querySelector("[data-emk-upsell-saving]");
    row.hidden = saving <= 0;
    popup.querySelector("[data-emk-upsell-saving-value]").textContent = "−" + money(saving);

    var label = popup.querySelector("[data-emk-upsell-submit-label]");
    label.textContent = selected.length ? label.getAttribute("data-with") : label.getAttribute("data-plain");
  }

  function open(detail) {
    pending = detail;
    var v = mainVariant();
    // Price as the page shows it (same money format as the store)
    var shown = document.querySelector(".product-block-list__item--info .price-list .price:not(.price--compare)");
    if (shown) {
      var copy = shown.cloneNode(true);
      copy.querySelectorAll(".visually-hidden").forEach(function (el) { el.remove(); });
      popup.querySelector("[data-emk-upsell-price]").textContent = copy.textContent.trim();
    }
    if (v) {
      var img = popup.querySelector("[data-emk-upsell-image]");
      if (img && v.featured_image && v.featured_image.src) {
        img.src = v.featured_image.src + (v.featured_image.src.indexOf("?") > -1 ? "&" : "?") + "width=160";
        img.removeAttribute("srcset");
      }
    }
    cards().forEach(function (card) { setSelected(card, false); });
    update();
    popup.hidden = false;
    document.documentElement.classList.add("emk-upsell-open");
    var close = popup.querySelector(".emk-upsell__close");
    if (close) close.focus();
    revealSubmit();
  }

  // Phone: the sheet is taller than the screen, so scroll it down until "Turpināt uz grozu" is fully visible
  function revealSubmit() {
    var dialog = popup.querySelector(".emk-upsell__dialog");
    var submit = popup.querySelector("[data-emk-upsell-submit]");
    if (!dialog || !submit) return;
    dialog.scrollTop = 0;
    if (!window.matchMedia("(max-width: 640px)").matches) return;
    requestAnimationFrame(function () {
      var gap = 20; // keep the sheet's bottom padding under the button
      var overflow = submit.getBoundingClientRect().bottom + gap - dialog.getBoundingClientRect().bottom;
      if (overflow <= 0) return;
      var top = dialog.scrollTop + overflow;
      if (dialog.scrollTo) dialog.scrollTo({ top: top, behavior: "smooth" });
      else dialog.scrollTop = top;
    });
  }

  // Hand the add back to the theme: refresh the cart and (when asked) open the drawer
  function finish(openCart, extraQuantity) {
    popup.hidden = true;
    document.documentElement.classList.remove("emk-upsell-open");
    var detail = pending || { quantity: 1, productAdded: true };
    pending = null;
    if (openCart) {
      document.documentElement.dispatchEvent(new CustomEvent("product:added", {
        bubbles: true,
        detail: { button: detail.button, variant: null, quantity: (detail.quantity || 1) + (extraQuantity || 0), productAdded: true, emkUpsell: true }
      }));
    } else {
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: { scrollToTop: false } }));
    }
  }

  function setSelected(card, on) {
    card.classList.toggle("is-selected", on);
    var toggle = card.querySelector("[data-emk-upsell-toggle]");
    if (toggle) toggle.setAttribute("aria-pressed", on ? "true" : "false");
  }

  window.addEventListener("product:added", function (event) {
    var d = event.detail || {};
    if (d.emkUpsell || !d.productAdded) return;
    // Only the main product form of this page (not quick buy in product rows)
    var button = d.button;
    if (!button || !button.closest || !button.closest(".product-block-list__item--info")) return;
    var detail = d;
    event.stopPropagation(); // the theme would open the cart drawer now
    (ready || Promise.resolve()).then(function () {
      if (cards().length) {
        document.dispatchEvent(new CustomEvent("theme:loading:end"));
        open(detail);
      } else {
        pending = detail;
        finish(true, 0);
      }
    });
  }, true);

  popup.addEventListener("click", function (event) {
    var toggle = event.target.closest("[data-emk-upsell-toggle]");
    if (toggle) {
      var card = toggle.closest("[data-emk-upsell-item]");
      setSelected(card, !card.classList.contains("is-selected"));
      update();
      return;
    }

    if (event.target.closest("[data-emk-upsell-close]")) {
      finish(false);
      return;
    }

    var submit = event.target.closest("[data-emk-upsell-submit]");
    if (submit) {
      var items = [];
      popup.querySelectorAll("[data-emk-upsell-item].is-selected").forEach(function (card) {
        items.push({ id: parseInt(card.getAttribute("data-variant-id"), 10), quantity: 1 });
      });
      if (!items.length) {
        finish(true, 0);
        return;
      }
      submit.disabled = true;
      fetch((window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : "/cart/add") + ".js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: JSON.stringify({ items: items })
      }).then(function () {
        submit.disabled = false;
        finish(true, items.length);
      }).catch(function () {
        submit.disabled = false;
        finish(true, 0);
      });
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && !popup.hidden) finish(false);
  });

  ready = loadComplementary();
})();
